export const flag = {
  msrp: 54.99,
  infoLink: 'https://www.teamtriton.com/custom-flags.html',
  items: [
    {
      number: 'FF100',
      hasModel: false,
    },
    {
      number: 'FF101',
      hasModel: false,
    },
    {
      number: 'FF102',
      hasModel: false,
    },
    {
      number: 'FF103',
      hasModel: false,
    },
    {
      number: 'FF104',
      hasModel: false,
    },
    {
      number: 'FF105',
      hasModel: false,
    },
    {
      number: 'FF106',
      hasModel: false,
    },
    {
      number: 'FF107',
      hasModel: false,
    },
    {
      number: 'FF108',
      hasModel: false,
    },
    {
      number: 'FF109',
      hasModel: false,
    },
    {
      number: 'FF110',
      hasModel: false,
    },
    {
      number: 'FF111',
      hasModel: false,
    },
    {
      number: 'FF112',
      hasModel: false,
    },
    {
      number: 'FF113',
      hasModel: false,
    },
    {
      number: 'FF114',
      hasModel: false,
    },
    {
      number: 'FF115',
      hasModel: false,
    },
  ],
};
